export default __webpack_public_path__ + "static/media/TIPIT_LOGO_V2_LOGO_WHITE-05.df472505.png";